export const getStartOfWeek = (date) => {
  const day = date.getDay();
  const diff = day === 0 ? -6 : 1 - day; // Якщо неділя, то віднімаємо 6 днів, інакше - віднімаємо кількість днів до понеділка
  const startOfWeek = new Date(date);
  startOfWeek.setDate(date.getDate() + diff); // Переміщаємо дату на понеділок
  return startOfWeek;
};